import { Container } from "./comonStyles";
import shield from "../../../../assets/icons/shield.svg";
import clock from "../../../../assets/icons/clock.svg";
import bals from "../../../../assets/icons/bals.svg";
import { Card, CardBody, CardButton, CardHeader, CardIcon, CardTextContainer } from "./cardStyles";

const Support = () => {
  return ( 
    <>
      <Container>
        <Card>
          <CardIcon src={shield}/>
          <CardTextContainer>
          <CardHeader>Bezpieczeństwo</CardHeader>
          <CardBody>Lorem Ipsum is simply dummy text of the printing and typesetting.</CardBody>
          <CardButton>Czytaj więcej</CardButton>
          </CardTextContainer>
        </Card>
        <Card>
          <CardIcon src={clock}/>
          <CardTextContainer>
          <CardHeader>Wsparcie 24/7</CardHeader>
          <CardBody>Lorem Ipsum is simply dummy text of the printing and typesetting.</CardBody>
          <CardButton>Czytaj więcej</CardButton>
          </CardTextContainer>
        </Card>
        <Card>
          <CardIcon src={bals}/>
          <CardTextContainer>
          <CardHeader>Najlepsza cena</CardHeader>
          <CardBody>Lorem Ipsum is simply dummy text of the printing and typesetting.</CardBody>
          <CardButton>Czytaj więcej</CardButton>
          </CardTextContainer>
        </Card>
      </Container>
    </>
  );
}

export default Support;

